import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-help-traffic-modal',
  templateUrl: './help-traffic-modal.component.html',
  styleUrls: ['./help-traffic-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonContent, IonTitle, IonIcon, IonButton, IonButtons, IonToolbar, IonHeader, TranslateModule],
})
export class HelpTrafficModalComponent {
  private readonly modalCtrl = inject(ModalController);

  reference: string | undefined;

  public async closeModalWithCancel(): Promise<boolean> {
    return this.modalCtrl.dismiss(null, 'cancel');
  }
}
